import { BreadcrumbItem } from "Components/Breadcrumb/Breadcrumb";
import dayjs from "dayjs";
import { format } from "../Utils/shared";
import { FORMAT_WITHOUT_TIME } from "./app";

export const dashboardBreadcrumb: BreadcrumbItem[] = [
  { title: "Dashboard", link: "" },
];

export const VehicleAssignmentRangeType = [
  { label: "Year", value: "year" },
  {
    label: "Month",
    value: "month",
  },
];

export const dashboardIssuesDetailInfo = [
  {
    label: "Status",
    key: "status",
  },
  {
    label: "Summary",
    key: "summary",
  },
  {
    label: "Description",
    key: "description",
  },
  {
    label: "Priority",
    key: "priority",
  },
  { label: "Vehicle", key: "vehicle" },
];

export const dashboardVehicleAssignmentDetailInfo = [
  {
    label: "Assigned Vehicle",
    key: "vehicle",
  },
  {
    label: "Operator",
    key: "operator.first_name",
  },
  {
    label: "Start Date/Time",
    key: "start_datetime",
  },
  {
    label: "End Date/Time",
    key: "end_datetime",
  },
  { label: "Duration", key: "duration" },
  {
    label: "Starting Odometer",
    key: "starting_odometer",
  },
  { label: "Ending Odometer", key: "ending_odometer" },
];

export const monthCalendarTableHeads = [
  {
    id: "title",
    month: 0,
    label: "",
  },
  {
    id: "",
    label: "Jan",
    month: 1,
  },
  {
    id: "",
    label: "Feb",
    month: 2,
  },
  {
    id: "",
    label: "Mar",
    month: 3,
  },
  {
    id: "",
    label: "Apr",
    month: 4,
  },
  {
    id: "",
    label: "May",
    month: 5,
  },
  {
    id: "",
    label: "Jun",
    month: 6,
  },
  {
    id: "",
    label: "Jul",
    month: 7,
  },
  {
    id: "",
    label: "Aug",
    month: 8,
  },
  {
    id: "",
    label: "Sep",
    month: 9,
  },
  {
    id: "",
    label: "Oct",
    month: 10,
  },
  {
    id: "",
    label: "Nov",
    month: 11,
  },
  {
    id: "",
    label: "Dec",
    month: 12,
  },
];

export const getLastDayOfMonthTill30 = () => {
  const today = dayjs();

  if (today.month() !== 1) {
    return today.date(30).format("YYYY-MM-DD");
  }

  return today.endOf("month").format("YYYY-MM-DD");
};

export const firstDateOfCurrentMonth = dayjs()
  .startOf("month")
  .format("YYYY-MM-DD");

export const lastDateOfCurrentMonth = getLastDayOfMonthTill30();

const currentYear = new Date().getFullYear();

export const firstDateOfCurrentYear = format(
  new Date(currentYear, 0, 1),
  FORMAT_WITHOUT_TIME,
);

export const lastDateOfCurrentYear = format(
  new Date(currentYear, 11, 31),
  FORMAT_WITHOUT_TIME,
);
